import { Truck } from "lucide-react";
import type { WidgetDef } from "../types";
import { StartsGlance, StartsView } from "./StartsWidget";
import { StartsSettings } from "./StartsSettings";

export interface StartsConfig {
  days: 7 | 14;
}

export const parseStartsConfig = (raw: unknown): StartsConfig => ({ days: (raw as StartsConfig | null)?.days === 14 ? 14 : 7 });

export const startsWidget: WidgetDef<StartsConfig> = {
  type: "starts",
  icon: Truck,
  title: "starts.title",
  description: "starts.description",
  sizes: ["s", "m", "l"],
  defaultSize: "m",
  defaultConfig: () => ({ days: 7 }),
  parseConfig: parseStartsConfig,
  available: (me) => me.role !== "carrier",
  View: StartsView,
  Glance: StartsGlance,
  Settings: StartsSettings,
};
